// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9339fde0","389":"7fc9550a","455":"bc829ad5","977":"38660c8c"}[chunkId] + ".chunk.js";
};